export const normalizeLicense = (response) => {
  return response.map((r) => {
    const license = { ...r };

    license.name =
      license.license_definition?.label || license.licenseDefinition.label;

    return license;
  });
};
